import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaArrowLeft } from 'react-icons/fa';
import './HideProfileModal.css';

const HideProfileModal = ({ show, onHide }) => {
  const [isHidden, setIsHidden] = useState(false);

  const handleToggle = () => {
    setIsHidden(!isHidden);
    // TODO: Add API call here when API is ready
    // await updateHideProfile(!isHidden);
  };

  const handleBack = () => {
    onHide();
  };

  return (
    <Modal show={show} onHide={handleBack} centered className="hide-profile-modal">
      <Modal.Body className="hide-profile-modal-body">

        <div className="hide-profile-content pt-4">
          {/* Header */}
          <div className="hide-profile-header">
            <button className="back-button" onClick={handleBack}>
              <FaArrowLeft />
            </button>
            <h4 className="hide-profile-title">Hide Profile</h4>
            <div className="toggle-switch-wrapper">
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={isHidden}
                  onChange={handleToggle}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          {/* Description */}
          <p className="hide-profile-description">
            Your profile can be hidden from the search and dashboard unless you like another member's profile first.
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HideProfileModal;

